export enum ScheduleNoteVisibility {
  TRAINER_ONLY = 'TRAINER_ONLY',
  CLIENT_ON_DAY = 'CLIENT_ON_DAY',
  CLIENT_ALWAYS = 'CLIENT_ALWAYS',
}
export enum ScheduleNoteNotifyRecepients {
  ME = 'ME',
  CLIENT = 'CLIENT',
  BOTH = 'BOTH',
}

export enum ScheduleNoteRecurrenceType {
  EVERY_N_DAYS = 'EVERY_N_DAYS',
  CUSTOM = 'CUSTOM',
}
